import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { pinsAtom } from '../stores/geolocationStore';
import { socket } from '../socket';

const useGeolocationHandler = () => {
  const setPins = useSetAtom(pinsAtom);

  useEffect(() => {
    const handleGeolocation = (data) => {
      setPins((prevPins) => {
        const existingPinIndex = prevPins.findIndex(
          (pin) => pin.techId === data.techId,
        );

        if (existingPinIndex !== -1) {
          const updatedPins = [...prevPins];
          updatedPins[existingPinIndex] = {
            ...updatedPins[existingPinIndex],
            lat: data.lat,
            long: data.long,
            animation: 'BOUNCE',
          };
          return updatedPins;
        }

        return [...prevPins, { ...data, animation: 'DROP' }];
      });
    };

    socket.on('geolocation', handleGeolocation);

    return () => {
      socket.off('geolocation', handleGeolocation);
    };
  }, [setPins]);
};

export default useGeolocationHandler;
